import { render } from "./TraineesMain.vue?vue&type=template&id=63370dcf"
import script from "./TraineesMain.vue?vue&type=script&lang=js"
export * from "./TraineesMain.vue?vue&type=script&lang=js"

import "./TraineesMain.vue?vue&type=style&index=0&id=63370dcf&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__